<template>
  <AppShell>
    <div class="page-head">
      <div><h1>{{ session?.client_name || 'Сессия' }}</h1><p class="muted">{{ session?.status }}</p></div>
      <div class="toolbar-row compact">
        <v-btn prepend-icon="mdi-broom" variant="tonal" @click="clearTable">Очистить стол</v-btn>
        <v-btn prepend-icon="mdi-close-circle-outline" color="error" variant="tonal" @click="closeSession">Закрыть</v-btn>
      </div>
    </div>
    <div class="split-grid wide">
      <v-card variant="flat" class="pa-3">
        <v-select v-model="catalogId" :items="catalogs" item-title="title" item-value="id" label="Каталог" @update:model-value="loadItems" />
        <div class="card-grid small">
          <MediaCard v-for="item in catalogItems" :key="item.id" :item="item" :selected="draftIds.includes(item.id)" @toggle="toggleDraft" />
        </div>
        <v-btn class="mt-4" block color="primary" prepend-icon="mdi-send" @click="sendToTable">Отправить на стол</v-btn>
      </v-card>
      <div>
        <v-alert v-if="clientOnline" type="success" variant="tonal" class="mb-4">Клиент в кабинете</v-alert>
        <h2>Стол клиента</h2>
        <div class="card-grid">
          <MediaCard v-for="item in state.table" :key="item.id" :item="item" :selected="state.selected_ids.includes(item.id)" />
        </div>
      </div>
    </div>
  </AppShell>
</template>

<script setup>
import { onBeforeUnmount, onMounted, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { api, unwrap } from '../api/http';
import { openSessionSocket } from '../api/socket';
import AppShell from '../components/AppShell.vue';
import MediaCard from '../components/MediaCard.vue';
const route = useRoute();
const session = ref(null);
const state = reactive({ table: [], selected_ids: [] });
const catalogs = ref([]);
const catalogId = ref(null);
const catalogItems = ref([]);
const draftIds = ref([]);
const clientOnline = ref(false);
let socket;
function applyState(next) { state.table = next.table || []; state.selected_ids = next.selected_ids || []; }
async function loadSession() { const data = unwrap(await api.get(`/api/sessions/${route.params.id}`)); session.value = data.session; applyState(data.state); }
async function loadItems() { catalogItems.value = catalogId.value ? unwrap(await api.get(`/api/catalogs/${catalogId.value}/items`)) : []; }
function toggleDraft(item) { draftIds.value = draftIds.value.includes(item.id) ? draftIds.value.filter((id) => id !== item.id) : [...draftIds.value, item.id]; }
async function sendToTable() { applyState(unwrap(await api.post(`/api/sessions/${route.params.id}/table`, { items: draftIds.value.map((id) => ({ catalog_item_id: id })) }))); }
async function clearTable() { applyState(unwrap(await api.post(`/api/sessions/${route.params.id}/clear`))); }
async function closeSession() { session.value = unwrap(await api.post(`/api/sessions/${route.params.id}/close`)); }
onMounted(async () => {
  await loadSession();
  catalogs.value = unwrap(await api.get('/api/catalogs'));
  socket = openSessionSocket({ token: localStorage.getItem('auth_token'), sessionId: Number(route.params.id), onEvent(event, data) {
    if (event === 'client_joined') clientOnline.value = true;
    if (['auth_ok', 'table_set', 'table_clear', 'selection_set'].includes(event)) applyState(data.state || data);
    if (event === 'session_closed') session.value.status = 'closed';
  } });
});
onBeforeUnmount(() => socket?.close());
</script>
